export default __webpack_public_path__ + "static/media/editimgeright.9936ca7d.png";